import React, { useState, useEffect } from 'react';
import { BackButtonHandler } from '../../utils/BackButtonHandler';
import Toast from './Toast';

const ToastManager: React.FC = () => {
	const [toastVisible, setToastVisible] = useState(false);
	const [toastMessage, setToastMessage] = useState('');

	useEffect(() => {
		const backButtonHandler = BackButtonHandler.getInstance();

		const handleToast = (data: { message: string, show: boolean }) => {
			if (data.show) {
				setToastMessage(data.message);
				setToastVisible(true);
			} else {
				setToastVisible(false);
			}
		};

		// Подписываемся на сигнал уведомлений
		const unsubscribe = backButtonHandler.toastSignal.subscribe(handleToast);

		return () => {
			// Отписываемся при размонтировании
			unsubscribe();
		};
	}, []);

	return <Toast message={toastMessage} isVisible={toastVisible} onHide={() => setToastVisible(false)} />;
};

export default ToastManager;